const header = {
  header: {
    logOut: 'Abmelden',
    enphaseStore: 'Enphase Store',
    enphaseSupport: 'Enphase Support ',
    comingSoon: 'Demnächst',
    new: 'Neu'
  }
};

export default header;
